module.exports = __webpack_public_path__ + "static/media/team-empty-icon.765b8643.svg";